import { useSearchParams } from 'react-router-dom';
import { API_LIST_LIMIT, PAGE_PARAM } from '@api';

interface UsePagePaginationReturn {
  currentPage: number;
  offset: number;
  pageSize: number;
  handlePageChange: (pageNumber: number) => void;
}

export const usePagePagination = (overridePageSize?: number): UsePagePaginationReturn => {
  const pageSize = overridePageSize || API_LIST_LIMIT;
  const [searchParams, setSearchParams] = useSearchParams();
  const currentPage = parseInt(searchParams.get(PAGE_PARAM) || '1');
  const offset = (currentPage - 1) * pageSize;

  const handlePageChange = (pageNumber: number) => {
    searchParams.set(PAGE_PARAM, String(pageNumber));
    setSearchParams(searchParams);
    window.scrollTo(0, 0);
  };

  return {
    currentPage,
    pageSize,
    offset,
    handlePageChange,
  };
};
